import type { BrickSet } from '../sets.ts'

// A generation job as the API reports it and the browser polls it. Stages
// run in this order; `failed` can replace any of them.

export type GenerateStage =
  | 'imagining'
  | 'sculpting'
  | 'bricking'
  | 'done'
  | 'failed'

export interface GenerateJob {
  id: string
  prompt: string
  stage: GenerateStage
  // The product render, once the image model has drawn it.
  image?: string
  set?: BrickSet
  error?: string
  createdAt: number
}

export const PROMPT_MAX = 80

// What the image model is asked for: one object, whole and plain, so the
// 3D model has a clean silhouette to lift and the texture has flat colour
// for the brick palette.
export function cleanPrompt(raw: string) {
  return raw
    .replace(/[\u0000-\u001f\u007f]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, PROMPT_MAX)
}
